import validator from 'validator';

const validate = (values) => {
  const errors = {};

  if (values.storeUrl && !validator.isURL(values.storeUrl, { allow_underscores: true })) {
    errors.storeUrl = 'Please enter a valid link';
  }

  return errors;
};

export default validate;
